import React, { useState, useEffect } from "react"
import { Link, useHistory, withRouter } from "react-router-dom"
import {
  Button,
  Col,
  Container,
  Row,
  Table,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import axios from "axios"
import PaginationComponent from "common/PaginationComponent"
import { convertPermission } from "permissionUtils"
import UnAuthorizedComponent from "common/UnAuthorizedComponent"
import VisitsFilter from "./VisitsFilter"
import LoadingInsider from "common/LoadingInsider"
import ViewVisits from "./ViewVisits"
import UpdateModal from "./UpdateModal"
import NOData from "common/NOData"
import TransferVisitsReport from "./TransferVisitsReport"
import ConfirmingAction from "common/ConfirmingAction"

const Visits = () => {
  const history = useHistory()

  // Inspector
  const [users, setUsers] = useState([])

  const [Creator, setCreator] = useState([])
  // Status
  const [stageList, setStageList] = useState([])

  // load the selected  data
  useEffect(() => {
    axios
      .post("https://althameen.net/dashboard/v1/all-users")
      .then(res => {
        setCreator(res.data.data)
      })
      .catch(err => console.log(err))
    const formData = {
      PerToken: localStorage.getItem("token"),
      PerUserID: localStorage.getItem("id"),
      PerRoleID: localStorage.getItem("userRoleID"),
      Catagory: "Inspection",
    }
    axios
      .post(process.env.REACT_APP_API_URL + "api/MenuUsersView", formData)
      .then(res => {
        if (res.data.error === true && res.data.message === "Access denied!") {
          setAuth(true)
          setTimeout(() => {
            history.push("/logout")
            setTimeout(() => {
              history.push("/login")
            }, 1000)
          }, 4000)
        }

        let data = Object.entries(res.data)
        data.splice(-1)
        let dataUsers = data.map(user => ({
          value: user[1].UserID,
          label: `${user[1].FirstName} ${user[1].LastName}`,
        }))
        setUsers(dataUsers)
      })
      .catch(error => {
        console.log(error)
      })

    axios
      .post(
        process.env.REACT_APP_API_URL + "api/inspection/InsStageList.php",
        formData
      )
      .then(res => {
        if (res.data.error === true && res.data.message === "Access denied!") {
          setAuth(true)
          setTimeout(() => {
            history.push("/logout")
            setTimeout(() => {
              history.push("/login")
            }, 1000)
          }, 4000)
        }

        let data = Object.entries(res.data)
        data.splice(-1)

        let stages = data.map(stage => ({
          value: stage[1].StageID,
          label: stage[1].StageName,
        }))
        setStageList(stages)
      })
      .catch(err => console.log(err))
  }, [])

  const [statusOptions, setStatusOptions] = useState([])

  useEffect(() => {
    const formData = {
      PerToken: localStorage.getItem("token"),
      PerUserID: localStorage.getItem("id"),
      PerRoleID: localStorage.getItem("userRoleID"),
    }
    axios
      .post(
        process.env.REACT_APP_API_URL + "api/Visits/VisitStatus.php",
        formData
      )
      .then(res => {
        if (res.data.error === true && res.data.message === "Access denied!") {
          setAuth(true)
          setTimeout(() => {
            history.push("/logout")
            setTimeout(() => {
              history.push("/login")
            }, 1000)
          }, 4000)
        }

        const options = []
        res.data.StatusList.map(item => {
          options.push({ value: item.StatusID, label: item.Status })
        })
        setStatusOptions(options)
      })
      .catch(err => console.log(err))
  }, [])

  console.log(statusOptions)

  // *********Document response*********/
  const [visitsList, setVisitsList] = useState([{}])

  // **************** Authorization ******************************
  const [auth, setAuth] = useState(false)

  // **********pagination *********************
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)

  //************** View Toggle ********************************//
  const [selectedItem, setSelectedItem] = useState()

  const [viewModal, setViewModal] = useState(false)

  // ************ Filter section *****************************
  const userPermissions = convertPermission(
    JSON.parse(localStorage.getItem("roles"))
  )

  const notAreamanger =
    userPermissions.R4.G === "1" ||
    userPermissions.R30.P === "1" ||
    userPermissions.R30.P === "2" ||
    userPermissions.R30.P === "3" ||
    userPermissions.R30.P === "4" ||
    userPermissions.R30.G === "1"

  const initialFilteredValues = notAreamanger
    ? {
        referenceNo: "",
        policyNo: "",
        inspector: "",
        status: "",
        startDate: "",
        endDate: "",
        startCreateDate: "",
        endCreateDate: "",
        dailyTask: 2,
      }
    : {
        referenceNo: "",
        policyNo: "",
        inspector: "",
        status: "",
        startDate: "",
        startCreateDate: "",
        endCreateDate: "",
        teamTask: 2,
        endDate: "",
        dailyTask: 2,
      }

  const [filteredValues, setFilteredValues] = useState(initialFilteredValues)
  const [isAreaManger, setIsAreaManger] = useState()
  const [loading, setLoading] = useState(true)
  const [editing, setEditing] = useState(false)

  const [updateData, setUpdateData] = useState(false)
  const syncDate = () => {
    setUpdateData(!updateData)
  }

  useEffect(() => {
    const controller = new AbortController()
    const signal = controller.signal
    const formData = {
      ...filteredValues,
      PerToken: localStorage.getItem("token"),
      PerUserID: localStorage.getItem("id"),
      PerRoleID: localStorage.getItem("userRoleID"),
      Page: page,
    }
    axios
      .post(
        process.env.REACT_APP_API_URL + "api/Visits/VisitList.php",
        formData,
        { signal }
      )
      .then(res => {
        if (res.data.error === true && res.data.message === "Access denied!") {
          setAuth(true)
          setTimeout(() => {
            history.push("/logout")
            setTimeout(() => {
              history.push("/login")
            }, 1000)
          }, 4000)
        }
        let array = Object.values(res.data)
        setTotalPages(res.data.TotalPages)
        setIsAreaManger(res.data.IsAreaManager)
        // setCleanReport(res.data.cleanReport)
        array.splice(-5)
        setVisitsList(array)
        setLoading(false)
      })
      .catch(err => {
        if (axios.isCancel(err)) {
          console.log("Request canceled", err.message)
        } else {
          console.error("Error fetching visits:", err)
        }
      })
    return () => {
      controller.abort()
    }
  }, [filteredValues, updateData, editing, page])

  const [addVisit, setAddVisit] = useState(false)

  //******************************** Transfer Report Toggle********************************//
  const [transferReportModal, setTransferReportModal] = useState(false)
  const transferReportToggle = () => {
    setTransferReportModal(!transferReportModal)
  }

  // ******************************** Confirm Delete Toggle********************************//
  const [confirmDelete, setConfirmDelete] = useState(false)
  const deleteVisit = () => {
    const formData = {
      PerToken: localStorage.getItem("token"),
      PerUserID: localStorage.getItem("id"),
      PerRoleID: localStorage.getItem("userRoleID"),
      ID: selectedItem.id,
      Deleted: "1",
    }
    axios
      .post(
        process.env.REACT_APP_API_URL + "api/Visits/VisitCont.php",
        formData
      )
      .then(res => {
        if (res.data.error === true) {
          setAuth(true)
          setTimeout(() => {
            history.push("/logout")
            setTimeout(() => {
              history.push("/login")
            }, 1000)
          }, 4000)
        }
        syncDate()
        setConfirmDelete(false)
      })
      .catch(err => console.log(err))
  }

  // Access denied !!
  if (auth) {
    return <UnAuthorizedComponent />
  }

  console.log(
    "userPermissions.R1.G === 1",
    userPermissions.R1.G === "1" ||
      userPermissions.R2.G === "1" ||
      userPermissions.R32.P === "1" ||
      userPermissions.R32.P === "2" ||
      userPermissions.R32.P === "3" ||
      userPermissions.R32.P === "4"
  )

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Reports" breadcrumbItem="Visits" />

          {/* ********************** Filter Section ***************************** */}
          <VisitsFilter
            filteredValues={filteredValues}
            setFilteredValues={setFilteredValues}
            setAuth={setAuth}
            isAreaManger={isAreaManger}
            statusOptions={statusOptions}
          />

          <div className="d-flex justify-content-end">
            <Button onClick={() => setAddVisit(true)}>Add Visit</Button>
          </div>
          <Row>
            <Col lg="12">
              <div className="">
                <div className="table-responsive">
                  {/******************* table section**************************/}
                  <Table className="project-list-table table-nowrap text-center align-middle table-borderless">
                    <thead>
                      <tr>
                        <th scope="col">ID</th>
                        <th scope="col">Reference No</th>
                        <th scope="col">Policy No</th>
                        <th scope="col">Request Date</th>
                        <th scope="col">Created By</th>
                        <th scope="col">Visit Date</th>
                        <th scope="col">Stage</th>
                        <th scope="col">Inspector</th>
                        <th scope="col">Status</th>
                        <th scope="col">Action</th>
                      </tr>
                    </thead>
                    {/***********table body *****************/}
                    <tbody>
                      {visitsList.map((item, key) => (
                        <tr key={key}>
                          <td>{item.id}</td>
                          <td>{item.ReferenceNo}</td>
                          <td>{item.PolicyNo}</td>
                          <td>{item.CreatedAt}</td>
                          <td>{item.CreatedBy}</td>
                          <td>{item.VisitDate}</td>
                          <td>{item.StageName}</td>
                          <td>{item.InspectorName}</td>
                          <td>{item.Status}</td>
                          <td>
                            <UncontrolledDropdown className="btn-group bg-primary">
                              <button
                                onClick={() => {
                                  setSelectedItem(item)
                                  setViewModal(true)
                                }}
                                className="btn btn-primary btn-sm dropdown-toggle"
                              >
                                View
                              </button>
                              <DropdownToggle
                                tag="a"
                                to="#"
                                className="card-drop"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <i className="mdi mdi-dots-horizontal font-size-18 text-light me-1"></i>
                              </DropdownToggle>
                              <DropdownMenu className="dropdown-menu-end">
                                {
                                  <DropdownItem
                                    onClick={() => {
                                      setSelectedItem(item)
                                      transferReportToggle()
                                    }}
                                  >
                                    Transfer To
                                  </DropdownItem>
                                }
                                {(userPermissions.R1.G === "1" ||
                                  userPermissions.R2.G === "1" ||
                                  userPermissions.R32.P === "1" ||
                                  userPermissions.R32.P === "2" ||
                                  userPermissions.R32.P === "3" ||
                                  userPermissions.R32.P === "4") && (
                                  <DropdownItem
                                    onClick={() => {
                                      setSelectedItem(item)
                                      setConfirmDelete(true)
                                    }}
                                  >
                                    Delete
                                  </DropdownItem>
                                )}
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>

                  {/* {loading && <LoadingInsider type="spin" color="gray" />} */}
                </div>
              </div>
            </Col>
          </Row>

          {visitsList.length > 1 && (
            <Row>
              <PaginationComponent
                page={page}
                setPage={setPage}
                totalPages={totalPages}
                setTotalPages={setTotalPages}
              />
            </Row>
          )}
          {viewModal && (
            <ViewVisits
              toggle={() => setViewModal(!viewModal)}
              isOpen={viewModal}
              selectedItem={selectedItem}
              syncDate={syncDate}
              stageList={stageList}
              users={users}
              statusOptions={statusOptions}
              userPermissions={userPermissions}
            />
          )}
          {addVisit && (
            <UpdateModal
              users={users}
              stageList={stageList}
              syncDate={syncDate}
              mode="add"
              isOpen={addVisit}
              toggle={() => setAddVisit(!addVisit)}
              viewVisitsToggle={() => setViewModal(!viewModal)}
              selectedItem={selectedItem}
              statusOptions={statusOptions}
              userPermissions={userPermissions}
            />
          )}
          {confirmDelete && (
            <ConfirmingAction
              Confirmetoggle={() => setConfirmDelete(!confirmDelete)}
              action={"delete"}
              massege={"Are you sure you want to delete this visit?"}
              ConfirmeModel={confirmDelete}
              confirmFunc={deleteVisit}
            />
          )}
        </Container>
        {<NOData data={visitsList} loading={loading} />}

        {/* ********************* Transfer Report *************************** */}
        {transferReportModal && (
          <TransferVisitsReport
            transferReportToggle={transferReportToggle}
            selectedItem={selectedItem}
            setAuth={setAuth}
            editing={editing}
            setEditing={setEditing}
          />
        )}
      </div>
    </React.Fragment>
  )
}

export default Visits
